import React from 'react';

import { reactQueryClient } from '~/api/reactQuery';
import { Button } from '~/atomic/atom/Button';
import { HomeAbonnementLink } from '~/atomic/atom/links/staticLinks';
import { getUserAbonnementCashName } from '~/atomic/page/bookSubscriptions/abonnementPage.data';
import { BuyAbonnementResultModal } from '~/feature/book/buyAbonnement/BuyAbonnementResultModal';

export const BuyAbonnementFromAbonnementPageResultModal = () => {
  return (
    <BuyAbonnementResultModal
      onSuccess={() => {
        reactQueryClient.invalidateQueries({ queryKey: getUserAbonnementCashName });
      }}
      buttons={[
        <HomeAbonnementLink key="go-to-catalog">
          <a>
            <Button
              type="primary"
              size="large"
            >
              Перейти к каталогу книг
            </Button>
          </a>
        </HomeAbonnementLink>,
      ]}
    />
  );
};
